export const isEmptyLetter = (str: string | null) => {
  return !str || !str.match(/\S/g)
}
